module.exports = __webpack_public_path__ + "static/media/girl.0c23ab5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/girl.png
// module id = 1684
// module chunks = 0